import * as React from 'react';
import classNames from 'classnames';
import { WizardNavTracker } from '@buyside/components/presentation/Form/Wizard/Wizard';

import Page0 from '@buyside/svgs/userApplicationNavigation/page0.svg';
import Page1 from '@buyside/svgs/userApplicationNavigation/page1.svg';
import Page2 from '@buyside/svgs/userApplicationNavigation/page2.svg';
import Page3 from '@buyside/svgs/userApplicationNavigation/page3.svg';

import styles from '../userApplicationPageStyles.scss';

interface PageHeaderProps {
  subHeader?: string;
}

interface WizardNavTrackerProps {
  page: number;
}

const PageHeader: React.FunctionComponent<PageHeaderProps> = ({
  subHeader
}): React.ReactElement => {
  return (
    <div className={classNames(styles.pageHeader, { [styles.noMargin]: !subHeader })}>
      <WizardNavTracker>
        {({ page }: WizardNavTrackerProps): React.ReactElement => {
          const components = [Page0, Page1, Page2, Page3];
          const Component = components[page];
          return <Component />;
        }}
      </WizardNavTracker>
      <h3>Application to Join SumZero</h3>
      {subHeader && <h4>{subHeader}</h4>}
    </div>
  );
};

export default PageHeader;
